import { internalFetch } from '../utils/fetchHelper';

export type PricingParameterScope = 'global' | 'tenant';

export interface IPricingParameterDefinition {
  key: string;
  valueType: 'integer' | 'decimal';
  unit: string;
  minimum: number;
  maximum: number;
  decimalPlaces: number;
}

export interface IPricingParameter {
  id: number;
  pricingItemId: number;
  key: string;
  value: number;
  effectiveFrom: string;
  effectiveTo: string | null;
  createdAt?: string | null;
  createdBy?: number | null;
  modifiedAt?: string | null;
  modifiedBy?: number | null;
}

export interface IResolvedPricingParameter extends IPricingParameter {
  source: 'Global' | 'Tenant';
}

export interface IPricingParameterBody {
  pricingItemId: number;
  key: string;
  value: number;
  effectiveFrom: string;
  effectiveTo: string | null;
}

export interface IResolvePricingParametersBody {
  pricingItemId: number;
  pricingDate: string;
}

const base = () => import.meta.env.VITE_BACKEND_API_URL as string;

const recordRoute: Record<PricingParameterScope, string> = {
  global: 'pricingParameter',
  tenant: 'tenantPricingParameter',
};

const listRoute: Record<PricingParameterScope, string> = {
  global: 'pricingParameters',
  tenant: 'tenantPricingParameters',
};

export const getPricingParameterDefinitions = async (
  abortController: AbortController
): Promise<IPricingParameterDefinition[]> =>
  internalFetch(
    `${base()}/p/pricingParameterDefinitions`,
    'GET',
    abortController
  );

export const getPricingParameters = async (
  abortController: AbortController,
  scope: PricingParameterScope,
  pricingItemId: number
): Promise<IPricingParameter[]> =>
  internalFetch(
    `${base()}/p/${listRoute[scope]}?pricingItemId=${pricingItemId}`,
    'GET',
    abortController
  );

export const resolvePricingParameters = async (
  abortController: AbortController,
  body: IResolvePricingParametersBody
): Promise<IResolvedPricingParameter[]> =>
  internalFetch(
    `${base()}/p/pricingParameters/resolve`,
    'POST',
    abortController,
    JSON.stringify(body)
  );

export const createPricingParameter = async (
  abortController: AbortController,
  scope: PricingParameterScope,
  body: IPricingParameterBody
): Promise<{ id: number }> =>
  internalFetch(
    `${base()}/p/${recordRoute[scope]}`,
    'POST',
    abortController,
    JSON.stringify(body)
  );

export const updatePricingParameter = async (
  abortController: AbortController,
  scope: PricingParameterScope,
  id: number,
  body: IPricingParameterBody
): Promise<{ id: number }> =>
  internalFetch(
    `${base()}/p/${recordRoute[scope]}/${id}`,
    'PUT',
    abortController,
    JSON.stringify(body)
  );

export const deletePricingParameter = async (
  abortController: AbortController,
  scope: PricingParameterScope,
  id: number
): Promise<void> =>
  internalFetch(
    `${base()}/p/${recordRoute[scope]}/${id}`,
    'DELETE',
    abortController
  );
